import { Controller } from "@hotwired/stimulus"

// Public storefront's per-product quantity +/- stepper. A logged-out
// visitor gets the "please log in" modal instead of a quantity change --
// gated on the presence of the hidden #current_user_id field, which the
// page only renders once a user is signed in.
export default class extends Controller {
  static targets = ["input"]

  decrement(event) {
    event.preventDefault()
    if (this.requireLogin()) return

    const current = parseInt(this.inputTarget.value) || 0
    this.inputTarget.value = Math.max(current - 1, 0)
  }

  increment(event) {
    event.preventDefault()
    if (this.requireLogin()) return

    const current = parseInt(this.inputTarget.value) || 0
    const max = this.inputTarget.hasAttribute("max") ? parseInt(this.inputTarget.getAttribute("max")) : 9
    this.inputTarget.value = Math.min(current + 1, max)
  }

  requireLogin() {
    if (document.getElementById("current_user_id")) return false

    bootstrap.Modal.getOrCreateInstance(document.getElementById("login_modal")).show()
    return true
  }
}
